<template>
  <div :class="{active: myShowPicker, disabled: disabled}" class="wh-popup-select">
    <van-field
      :name="name"
      :value="value"
      style="display: none"
    />
    <span
      class="wh-flex-between"
      @click="togglePopupPicker(true)"
    >
      <slot>
        <van-field
          class="input"
          :style="{
            width: width
          }"
          :rules="rules"
          readonly
          clickable
          :value="myShowText"
          :placeholder="placeholder"
          style="padding: 0;"
          :label="label"
        />
      </slot>
      <slot name="right-icon">
        <van-icon v-if="!disabled" class="right-icon" name="arrow-down" />
      </slot>
    </span>
    <van-popup v-model="myShowPicker" round position="bottom">
      <slot name="select">
        <van-picker
          :visible-item-count="visibleItemCount"
          :item-height="itemHeight"
          :title="title"
          :default-index="defaultSelectedIndex"
          show-toolbar
          :columns="columns"
          @cancel="togglePopupPicker(false)"
          @confirm="onConfirm"
        />
      </slot>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'WhPopupSelect',
  model: {
    event: 'change',
    prop: 'value'
  },
  props: {
    value: {
      type: [String, Boolean, Number],
      default: undefined
    },
    rules: {
      type: Array,
      default() {
        return []
      }
    },
    itemHeight: {
      type: Number,
      default: 44
    },
    visibleItemCount: {
      type: Number,
      default: 6
    },
    width: {
      type: String,
      default: '100%'
    },
    showText: {
      type: String,
      default: undefined
    },
    name: {
      type: String,
      default: undefined
    },
    title: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    label: {
      type: String,
      default: undefined
    },
    showPicker: {
      type: Boolean,
      default: false
    },
    columns: {
      type: Array,
      default() {
        return [
          // {
          //   text: '选项2',
          //   value: 2
          // },
          // {
          //   text: '选项1',
          //   value: 1
          // }
        ]
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      myShowPicker: false,
      myShowText: '',
      defaultSelectedIndex: undefined
    }
  },
  watch: {
    value: {
      handler(newVal) {
        this.setSelectActiveItem(this.columns, newVal)
      },
      immediate: true
    },
    columns: {
      handler(newVal) {
        this.setSelectActiveItem(newVal, this.value)
      },
      immediate: true
    },
    showPicker: {
      handler(newVal) {
        this.myShowPicker = newVal
      },
      immediate: true
    },
    showText: {
      handler(newVal) {
        this.myShowText = newVal
      },
      immediate: true
    }
  },
  methods: {
    setSelectActiveItem(columns, value) {
      this.defaultSelectedIndex = undefined
      this.myShowText = ''
      for (const index in columns) {
        if (value === columns[index].value) {
          this.myShowText = columns[index].text
          this.defaultSelectedIndex = index
          break
        }
      }
    },
    onConfirm(item) {
      this.myShowText = item.text
      this.togglePopupPicker(false)
      this.$emit('change', item.value)
      this.$emit('itemChange', item)
    },
    togglePopupPicker(val) {
      if (!this.disabled) {
        this.myShowPicker = val
        this.$emit('update:showPicker', val)
      }
    }
  }
}
</script>

<style lang='less' scoped>
.wh-popup-select {
  padding: 10px 16px;
  .right-icon {
    transition: all 0.3s;
  }
  &.active {
    .right-icon {
      transform: rotateZ(180deg);
      color: @primary-color;
    }
  }
  &.disabled {
    /deep/ .input {
      .van-field__control {
        color: #ccc;
      }
    }
  }
}
</style>
